/* eslint-disable jsx-a11y/role-supports-aria-props */
/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import { useLocation } from "react-router-dom";
import { NavLink } from "react-router-dom";
import { Newspaper, ReceiptCutoff, QuestionCircle } from "react-bootstrap-icons";
// import SVG from "react-inlinesvg";
import { /*toAbsoluteUrl,*/ checkIsActive } from "../../../../_helpers";

export function AsideMenuList({ layoutProps }) {
  const location = useLocation();
  const getMenuItemActive = (url, hasSubmenu = false) => {
    return checkIsActive(location, url)
      ? ` ${!hasSubmenu &&
          "menu-item-active"} menu-item-open menu-item-not-hightlighted`
      : "";
  };

  return (
    <>
      {/* begin::Menu Nav */}
      <ul className={`menu-nav ${layoutProps.ulClasses}`}>
        {/* Service Catalogue */}
        {/*begin::1 Level*/}
        <li
          className={`menu-item ${getMenuItemActive("/catalogue-management", false)}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/catalogue-management">
            <span className="svg-icon menu-icon">
            {/* <SVG src={toAbsoluteUrl("/media/svg/icons/Design/Layers.svg")} /> */}
              <Newspaper/>
            </span>
            <span className="menu-text">Service Catalogues</span>
          </NavLink>
        </li>
        {/*end::1 Level*/}

        {/* Refund Request */}
        {/*begin::1 Level*/}
        {/* <li
          className={`menu-item ${getMenuItemActive("/refund-request", false)}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/refund-request">
            <span className="svg-icon menu-icon">
            <SVG src={toAbsoluteUrl("/media/svg/icons/Text/Undo.svg")} />
            </span>
            <span className="menu-text">Refund Request</span>
          </NavLink>
        </li> */}
        {/*end::1 Level*/}

        {/* Refund Request */}
        {/*begin::1 Level*/}
        <li
          className={`menu-item ${getMenuItemActive("/receipt-retrieval", false)}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/receipt-retrieval">
            <span className="svg-icon menu-icon">
            {/* <SVG src={toAbsoluteUrl("/media/svg/icons/General/Search.svg")} /> */}
              <ReceiptCutoff/>
            </span>
            <span className="menu-text">Retrieve Receipt</span>
          </NavLink>
        </li>
        {/*end::1 Level*/}

        {/* Help */}
        {/*begin::1 Level*/}
        <li
          className={`menu-item ${getMenuItemActive("/help", false)}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/help">
            <span className="svg-icon menu-icon">
              {/* <SVG src={toAbsoluteUrl("/media/svg/icons/Code/Question-circle.svg")} /> */}
              <QuestionCircle/>
            </span>
            <span className="menu-text">Help</span>
          </NavLink>
        </li>
        {/*end::1 Level*/}  
      </ul>

      {/* end::Menu Nav */}
    </>
  );
}
